import { useSelector } from 'react-redux';

// Components
import Main from 'components/common/Layout/Main';
import AboutUs from 'components/templates/about';

// Libs
import Translation from 'libs/Translation';

const About = () => {
	const {webConfig} = useSelector(state => state.core);

    const title = Translation.t('title.about');
	const description = Translation.t('text.vclinic-get-appointment-online');

	const breadCrumb = {
		itemListElements: [
			{
				position: 1,
				name: Translation.t('title.default'),
				item: 'https://vclinic.io',
			},
			{
				position: 2,
				name: Translation.t('title.about'),
				item: `https://vclinic.io/about`,
			},
		],
	};

	const seo = {
		title: `${title} | ${Translation.t('title.default')}`,
        description: description,
		h1Title: title,
		additionalMetaTags: [],
	};

    return (
        <Main breadCrumb={breadCrumb} seo={seo}>
            <AboutUs webConfig={webConfig}/>
        </Main>
    )
}
export default About;